import { ArrowRight, LockKeyhole, MessageSquareText, ShieldCheck } from "lucide-react";
import { BrandWordmark } from "../../components/BrandWordmark";

export function AdminLoginLink() {
	return (
		<a
			className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-lg bg-ink-950 px-5 text-sm font-bold text-white transition hover:bg-stone-700 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-brand-500/25"
			href="/admin/operations"
		>
			관리자 로그인 <ArrowRight className="size-4" aria-hidden="true" />
		</a>
	);
}

export function HomePage() {
	return (
		<div className="min-h-screen bg-stone-50 text-ink-950">
			<header className="mx-auto flex w-full max-w-6xl items-center justify-between px-5 py-6 sm:px-8">
				<BrandWordmark />
				<a
					className="inline-flex min-h-11 items-center gap-2 rounded-lg px-3 text-sm font-bold text-stone-700 transition hover:bg-white hover:text-ink-950 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-brand-500/25"
					href="https://www.theline.kr/"
					target="_blank"
					rel="noreferrer"
				>
					더라인 공식 홈페이지 <ArrowRight className="size-4" aria-hidden="true" />
				</a>
			</header>

			<main className="mx-auto grid w-full max-w-6xl gap-12 px-5 pb-16 pt-10 sm:px-8 sm:pt-20 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-20">
				<section>
					<p className="mb-5 inline-flex items-center gap-2 rounded-full border border-gold-500/25 bg-gold-50 px-3 py-1.5 text-xs font-extrabold tracking-wide text-gold-500">
						<ShieldCheck className="size-4" aria-hidden="true" /> THELINE CARE
					</p>
					<h1 className="max-w-xl text-[clamp(2.5rem,7vw,5rem)] font-extrabold leading-[1.05] tracking-[-0.065em] text-ink-950">
						진료 이후에도,
						<br />
						세심하게 듣겠습니다.
					</h1>
					<p className="mt-7 max-w-lg text-base leading-8 text-stone-700 sm:text-lg">
						더라인 고객 케어는 상담부터 회복 과정까지 고객님의 경험을 안전하게 듣고 필요한 후속
						관리를 연결합니다.
					</p>
					<div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-stone-700">
						<span className="inline-flex items-center gap-2">
							<LockKeyhole className="size-4 text-gold-500" /> 초대받은 고객만 참여
						</span>
						<span className="inline-flex items-center gap-2">
							<MessageSquareText className="size-4 text-gold-500" /> 답변 기반 후속 관리
						</span>
					</div>
				</section>

				<section className="overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-[0_28px_80px_rgb(25_24_22/0.09)]">
					<div className="border-b border-stone-200 p-6 sm:p-8">
						<span className="grid size-11 place-items-center rounded-2xl bg-brand-50 text-brand-700">
							<MessageSquareText className="size-5" aria-hidden="true" />
						</span>
						<h2 className="mt-5 text-xl font-extrabold tracking-[-0.03em]">고객 만족도 설문</h2>
						<p className="mt-2 text-sm leading-6 text-stone-700">
							문자나 카카오톡으로 전달받은 전용 링크를 이용해 주세요. 개인정보 보호를 위해 이
							화면에서는 고객번호나 초대 코드를 입력받지 않습니다.
						</p>
						<div className="mt-5 rounded-xl bg-stone-50 px-4 py-3 text-xs font-semibold leading-5 text-stone-700">
							링크가 열리지 않거나 참여 기간이 지난 경우 담당 상담실장에게 문의해 주세요.
						</div>
					</div>
					<div className="flex flex-col gap-4 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
						<div>
							<strong className="block text-sm">더라인 운영 담당자이신가요?</strong>
							<small className="mt-1 block text-xs text-stone-500">
								승인된 업무용 계정으로만 접속할 수 있습니다.
							</small>
						</div>
						<AdminLoginLink />
					</div>
				</section>
			</main>

			<footer className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-between gap-3 border-t border-stone-200 px-5 py-6 text-xs text-stone-500 sm:px-8">
				<span>© THE LINE PLASTIC SURGERY. All rights reserved.</span>
				<span>고객 경험 개선을 위한 비공개 설문 서비스</span>
			</footer>
		</div>
	);
}
